// 导入Pinia的defineStore方法和API模块
import {defineStore} from 'pinia'
import {Api} from '@/api'
import Mock from 'mockjs';

// 使用defineStore创建一个名为'user'的存储
// Pinia存储类似于Vuex的store，但更轻量且支持TypeScript
export const useUserStore = defineStore('user', {
    // state定义存储的状态数据
    state: () => ({

        token: localStorage.getItem('token') || null, // 从本地存储获取token或设为null
        isAuthenticated: !!localStorage.getItem('token'), // 根据token存在与否设置认证状态
        userInfo: null, // 用户信息对象
        role: '', // 用户角色：'doctor'或'patient'
        patients: [],
        patientDetails: {},
        records: {}


    }),

    // getters定义计算属性，类似于Vue的计算属性
    getters: {
        isDoctor: (state) => state.role === 'doctor', // 判断是否是医生角色
        isPatient: (state) => state.role === 'patient', // 判断是否是患者角色
    },

    // actions 是用于封装异步逻辑的方法集合。
    // 它们可以调用 mutations 来更新 state，也可以调用其他 actions。
    actions: {
        // 设置token并更新认证状态
        setToken(token) {
            this.token = token
            this.isAuthenticated = !!token
            if (token) {
                localStorage.setItem('token', token) // 持久化token到本地存储
            } else {
                localStorage.removeItem('token') // 移除本地存储中的token
            }
        },

        // 登录方法
        async login(role, data) {
            // 调用API获取真实登录请求（附加 role，演示模式下 Mock 根据角色返回演示账号）
            const loginResponse = await Api.login({ ...data, role });
            // 使用真实token或生成模拟token(用于开发环境)
            const token = loginResponse.token || `mock-token-${Mock.Random.guid()}`;
            this.setToken(token);
            this.userInfo = loginResponse
            this.role =  loginResponse.role || ''
            this.saveToLocalStorage() // 保存到本地存储

            // 登录成功后清除今日提醒状态，确保每次登录都重置为未完成
            localStorage.removeItem('reminderStates');

            console.log('Login success, role set to:', this.role); // 调试日志

            // 登录成功后获取患者列表并存储到本地
            if (this.role === 'doctor') {
                const response = await Api.fetchPatients();
                if (response && response.data) {
                    localStorage.setItem('patients', JSON.stringify(response.data));
                    this.patients = response.data;
                }
            }else if(this.role === 'patient') {
                const response = await Api.fetchPatientDetail(loginResponse.id);
                console.log(response);
                if (response && response.data) {
                    localStorage.setItem('patientDetails', JSON.stringify(response.data))
                    console.log("patientDetails:", JSON.parse(localStorage.getItem('patientDetails')));
                    this.patientDetails = response.data;
                }
                return response;
            }
        },


        // 登出方法
        async logout() {
            try {
                await Api.logout()
            } catch (error) {
                // console.error('登出失败', error)
            }
            this.setToken(null)
            localStorage.removeItem('userState')

            // 强制刷新页面以完全重置路由和状态
            // 前缀由 vue.config.js 注入的 ROUTER_BASE 提供：默认 "/"，子路径部署时为部署目录（带尾斜杠）
            window.location.href = (process.env.ROUTER_BASE || "/") + "login"
        },


        // 保存用户状态到本地存储
        saveToLocalStorage() {
            const state = {
                token: this.token,
                isAuthenticated: this.isAuthenticated,
                role: this.role,
                userInfo: this.userInfo
            }
            localStorage.setItem('userState', JSON.stringify(state))
        },

        // 从本地存储加载用户状态
        loadFromLocalStorage() {
            const savedState = localStorage.getItem('userState');
            if (savedState) {
                try {
                    const state = JSON.parse(savedState);
                    this.token = state.token || null;
                    this.isAuthenticated = state.isAuthenticated || false;
                    this.role = state.role || '';
                    this.userInfo = state.userInfo || null;

                    // 加载patients
                    const patients = localStorage.getItem('patients');
                    if (patients) {
                        try {
                            this.patients = JSON.parse(patients);
                        } catch (e) {
                            this.patients = [];
                            localStorage.setItem('patients',"[]");
                        }
                    }

                    // 加载patientDetails
                    const patientDetails = localStorage.getItem('patientDetails');
                    if (patientDetails) {
                        try {
                            this.patientDetails = JSON.parse(patientDetails);
                        } catch (e) {
                            this.patientDetails = {};
                            localStorage.setItem('patientDetails',"{}");
                        }
                    }

                    // 加载records
                    const records = localStorage.getItem('records');
                    if (records) {
                        try {
                            this.records = JSON.parse(records);
                        } catch (e) {
                            this.records = {};
                            localStorage.setItem('records',"{}");
                        }
                    }

                    return true;
                } catch (error) {
                    // 如果解析失败，清除损坏的本地存储数据
                    localStorage.removeItem('userState');
                    return false;
                }
            }
            return false;
        },
        //获取病人列表
        async fetchPatients() {
            const response = await Api.fetchPatients();
            if (response && response.data) {
                this.patients = response.data;
                localStorage.setItem('patients', JSON.stringify(response.data));
            }
            return response;
        }, //获取一个病人详情
        async fetchPatientDetail(patientId) {
            const response = await Api.fetchPatientDetail(patientId);
            if (response && response.data) {
                this.patientDetails = response.data;
                localStorage.setItem('patientDetails', response.data)
            }
            return response;
        }, //获取一个记录详情
        async fetchRecords(recordId) {
            const response = await Api.fetchRecords(recordId);
            if (response && response.data) {
                this.records = response.data;
                localStorage.setItem('records', JSON.stringify(response.data))
            }
            return response;
        },
    },
})
